import { render, staticRenderFns } from "./Retention.vue?vue&type=template&id=1c4d1571&scoped=true&"
import script from "./Retention.vue?vue&type=script&lang=js&"
export * from "./Retention.vue?vue&type=script&lang=js&"
import style0 from "./Retention.vue?vue&type=style&index=0&id=1c4d1571&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d1571",
  null
  
)

export default component.exports